import { Dialog, Grid, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import setToast from "../../helpers/toaster.helper";
import { PhoneNumberModel } from "../../models/phone-number.model";
import { SettingsService } from "../../services/SettingsService";
import { UtilityService } from "../../services/UtilityService";
import ButtonComponent from "../shared/button/button.component";
import { buttonLabels, ToasterTexts } from "../shared/constants";
import SubpageHeaderComponent from '../shared/subpage-header.component';
import { ToasterType } from "../shared/toaster/toaster.model";
import EditSettings from "./edit-settings.component";
import { BackIcon, CancelIcon, EditIcon, SettingsBulkMessageIcon, SettingsGroupContactsIcon, SettingsPinnedContactsIcon } from "../../icon";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"


interface Props {
    OnClose: () => void,
    Settings: boolean,
    PhoneNumber: string,
}

const Settings = (props: Props) => {

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)

    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [phoneSettings, setPhoneSettings] = useState<any>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        refreshData()
    }, [])

    const refreshData = () => {
        SettingsService.getSettingByPhoneNumber(props.PhoneNumber?.replace(/[^\d]/g, "")).then(res => {
            setPhoneSettings(res.data)
        }).catch(err => console.log(err))
    }

    const handleSave = (event: any) => {
        event.preventDefault();
        setIsLoading(true)
        let Name = PhoneNumbers.find((x: PhoneNumberModel) => x.PhoneNumber === props.PhoneNumber)?.Name || UtilityService.maskPhoneNumber(props.PhoneNumber);
        SettingsService.UpdatePhoneSettings(props.PhoneNumber?.replace(/[^\d]/g, ""), phoneSettings).then(res => {
            setIsLoading(false)
            handleBack();
            onClose();
            setToast(ToasterTexts.PHONE_NUMBER_SETTINGS_EDIT_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS);
        }).catch(err => {
            setIsLoading(false)
            setToast(ToasterTexts.ERROR, ToasterType.SUCCESS);
            console.log("An error occured!", err)
        })
    }
    const onClose = () => {
        props.OnClose();
        refreshData();
        handleBack();
    }
    const handleBack = () => {
        setIsEdit(false)
    }
    const handleButton = () => {
        setIsEdit(true)
    }

    const handleContactCount = (e: any) => {
        e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
        let item = phoneSettings.map(
            obj => (obj.id === e.target.id ? Object.assign(obj, { value: e.target.value }) : obj)
        )
        setPhoneSettings(item)
    }

    const handlePinCount = (num: any, id: string | undefined) => {

        var item = phoneSettings.map(
            obj => (obj.id === id ? Object.assign(obj, { value: num }) : obj)
        )
        item[0].value = item[0].value.toString();
        setPhoneSettings(item)
    }

    const isSaveDisabled = () => {
        return phoneSettings.some(x => {
            return (x.code === "MGC" || x.code === "MMC") && (!x.value || x.value.trim() === '');
        });
    }

    return (
        !IsMobileDevice ?
            <Dialog maxWidth='sm'
                BackdropProps={{ style: { backgroundColor: "transparent" } }}
                classes={{ paper: "br-2 dialogue-shadow" }}
                fullWidth={true} onClose={onClose} aria-labelledby="customized-dialog-title" open={props.Settings}

                disableEscapeKeyDown
            >
                <DialogTitle id="customized-dialog-title" className={`bb-primary-divider-4 px-2 pt-2 pb-1`}>
                    {isEdit ?
                        <div className="h1-semibold color-text-field-font d-flex align-center" id="customized-dialog-title">
                            <span className={`d-flex`}><BackIcon className={"c-pointer p-1 icon-primary"} onClick={handleBack} />
                                <span className={`my-auto`}>{"Edit Settings"}</span></span>
                            <Tooltip title='Close' placement='bottom'>
                                <span className={"ml-auto mr-1 my-auto"}>
                                    <CancelIcon className={"c-pointer"} onClick={onClose} /></span>
                            </Tooltip>
                        </div> :
                        <div className="h1-semibold color-text-field-font d-flex" id="customized-dialog-title">
                            <div className={"my-auto"}> {"Settings"}</div>
                            <div className={"ml-auto my-auto d-flex align-center"}>
                                <Tooltip title='Edit' placement='bottom'>
                                    <div onClick={handleButton} className="icon-primary c-pointer" style={{ padding: "0.375rem 0.75rem" }}>
                                        <EditIcon className={`c-pointer`} />
                                    </div>
                                </Tooltip>
                                <Tooltip title='Close' placement='bottom'>
                                    <CancelIcon className={"c-pointer p-1 px-2 icon-primary"} onClick={onClose} />
                                </Tooltip>
                            </div>
                        </div>}
                </DialogTitle>
                <DialogContent className={`p-0 ${isEdit ? '' : 'pb-5'}`}>
                    <form noValidate autoComplete="off" onSubmit={handleSave}>
                        {isEdit ?
                            <EditSettings IsMobileDevice={IsMobileDevice}
                                PhoneSettings={phoneSettings} HandleContactCount={handleContactCount} HandlePinCount={handlePinCount} /> :
                            <>
                                {phoneSettings.map((settings) =>
                                    <Grid container className={"bb-primary-divider-4"}>
                                        <Grid item xs={IsMobileDevice ? 10 : 10} className={`${IsMobileDevice ? '' : ''} pl-2 t-align-left d-flex align-center`}>
                                            {settings.code === "MPC" ? <SettingsPinnedContactsIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> : settings.code === "MGC" ? <SettingsGroupContactsIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> : settings.code === "MMC" ? <SettingsBulkMessageIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> : ''}
                                            <p className={`${IsMobileDevice ? "h2" : "h3-regular"} color-settings-items-heading t-align-left`}>
                                                {settings.name}
                                            </p>
                                        </Grid>
                                        <Grid item className={`b-none d-flex justify-center my-auto ${IsMobileDevice ? "h2" : "h3-semibold"}`} xs={IsMobileDevice ? 2 : 2}>
                                            {settings.value}
                                        </Grid>
                                    </Grid>
                                )
                                }
                            </>
                        }
                        {isEdit && <div className={`${isEdit && 'pb-2'} d-flex float-right mt-2`}>
                            <ButtonComponent OnClick={onClose} ButtonLabel={buttonLabels.CANCEL} ClassName={" h5-regular c-pointer mr-1"} Variant={"secondary-btn-small"} />
                            <ButtonComponent Type="submit" ButtonLabel={buttonLabels.SAVE} ClassName={"h5-regular c-pointer pr-3 pl-3 mr-2"} Variant={isSaveDisabled() ? "disabled-btn-small" : "primary-btn-small"} Loading={isLoading} />
                        </div>

                        }
                    </form>
                </DialogContent >

            </Dialog > :
            <div className={"d-flex flex-direction paper-background h-v-100"}>
                <SubpageHeaderComponent
                    HeaderText={`${!isEdit ? "Settings" :
                        "Edit Settings"}`} PreviousPage={!isEdit ? props.OnClose : handleBack} />
                <span className="d-flex p-absolute edit-close-settings" style={{ zIndex: 100 }}>
                    {!isEdit && <EditIcon onClick={handleButton} className={`c-pointer `} />}
                </span>
                <div className=''>
                    {isEdit ?
                        <EditSettings IsMobileDevice={IsMobileDevice} PhoneSettings={phoneSettings} HandleContactCount={handleContactCount} HandlePinCount={handlePinCount} /> :
                        <>
                            {phoneSettings.map((settings) =>
                                <Grid container className={"bb-primary-divider-4"}>
                                    <Grid item xs={IsMobileDevice ? 10 : 10} className={`${IsMobileDevice ? '' : ''} pl-2 t-align-left d-flex `}>
                                        {settings.code === "MPC" ? <SettingsPinnedContactsIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> : settings.code === "MGC" ? <SettingsGroupContactsIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> : settings.code === "MMC" ? <SettingsBulkMessageIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> : ''}
                                        <p className={`${IsMobileDevice ? "h2" : "h3-regular"} color-settings-items-heading t-align-left`}>
                                            {settings.name}
                                        </p>
                                    </Grid>
                                    <Grid item className={`b-none d-flex justify-center my-auto ${IsMobileDevice ? "h2" : "h3-semibold"}`} xs={IsMobileDevice ? 2 : 2}>
                                        {settings.value}
                                    </Grid>
                                </Grid>
                            )
                            }
                        </>}
                </div>
                <div className='px-2 pt-3 mt-auto'>
                    {isEdit &&
                        <>
                            <ButtonComponent OnClick={(e) => handleSave(e)} ButtonLabel={buttonLabels.SAVE.toUpperCase()} ClassName={"h2 c-pointer w-p-100 justify-center mr-2 br-6"} Variant={isSaveDisabled() ? "disabled-btn-small" : "primary-btn-small"} Loading={isLoading} />
                            <ButtonComponent OnClick={onClose} ButtonLabel={buttonLabels.CANCEL.toUpperCase()} ClassName={` h2 c-pointer w-p-100 justify-center mr-2 br-6 mt-2 mb-3`} Variant={"secondary-btn-small"} />
                        </>
                    }
                </div>
            </div >
    )
}
export default Settings